<script setup lang="ts">
import { onMounted } from 'vue'
import { useStore } from 'vuex'
import { config } from '@/lib/helpers/config.helpers'

const store = useStore()

const redirectToLogin = () => {
  const redirectUrl = new URL('/auth/login', config.identityAppUrl)
  redirectUrl.searchParams.append('app', 'admin')
  redirectUrl.searchParams.append('returnUrl', window.location.origin)
  window.location.replace(redirectUrl.toString())
}

onMounted(async () => {
  const logoutUrl = await store.dispatch('auth/logout')

  if (logoutUrl) {
    window.location.href = logoutUrl
  } else {
    redirectToLogin()
  }
})
</script>
<template>
  <div></div>
</template>
